import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../store/auth";

// Gate protected routes behind a validated session. Unauthed → /login,
// preserving the attempted location so login can bounce back.
export function RequireToken({ children }: { children: ReactNode }) {
  const authed = useAuth((s) => s.authed);
  const location = useLocation();
  if (!authed) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
